import { ErrorMessage } from "../../external/types/errors";
import { AnyAction } from "redux";
import { commonActionKeys } from "src/common/actions/commonActionKeys";

export const showErrorMessage = (errorMessage: ErrorMessage): AnyAction => {
  return {
    type: commonActionKeys.SHOW_ERROR_MESSAGE,
    errorMessage
  };
};

export const dismissErrorDialog = (errorMessage: ErrorMessage): AnyAction => {
  return {
    type: commonActionKeys.DISMISS_ERROR_DIALOG,
    errorMessage
  };
};

export const clearErrorMessage = (): AnyAction => {
  return {
    type: commonActionKeys.CLEAR_ERROR_MESSAGE
  };
};
